function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Common from "../components/includes/Common";
import { Container, Row, Col } from "react-bootstrap";
import { notification, Skeleton, Divider, Button, Modal, DatePicker, Form, Statistic, Table, Space, Drawer } from "antd";
import { CartPlusFill, CashStack, PlusCircleFill, Receipt, Search } from "react-bootstrap-icons";
import AddCustomerOrder from "../components/forms/AddCustomerOrder";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import moment from "moment";
import Moment from "react-moment";
import dayjs from "dayjs";
import Invoice from "../components/Invoice";
import SettlementHistory from "../components/SettlementHistory";
import AddCustomerSettlement from "../components/forms/AddCustomerSettlement";
import { Icon } from "@iconify/react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var CompanyDetails = function CompanyDetails() {
  var _useParams = useParams(),
    id = _useParams.id;
  var ref = useRef();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    company = _useState2[0],
    setCompany = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    orders = _useState6[0],
    setOrders = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showNewOrder = _useState8[0],
    setShowNewOrder = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isDataChanged = _useState10[0],
    setIsDataChanged = _useState10[1];
  var _useState11 = useState(moment().startOf('month').format()),
    _useState12 = _slicedToArray(_useState11, 2),
    from = _useState12[0],
    setFrom = _useState12[1];
  var _useState13 = useState(moment().endOf('month').format()),
    _useState14 = _slicedToArray(_useState13, 2),
    to = _useState14[0],
    setTo = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedBill = _useState16[0],
    setSelectedBill = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showInvoice = _useState18[0],
    setShowInvoice = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showAddSettlement = _useState20[0],
    setShowAddSettlement = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showSettleHistory = _useState22[0],
    setShowSettleHistory = _useState22[1];
  var _useState23 = useState(0),
    _useState24 = _slicedToArray(_useState23, 2),
    totalOrderAmount = _useState24[0],
    setTotalOrderAmount = _useState24[1];
  var _useState25 = useState(0),
    _useState26 = _slicedToArray(_useState25, 2),
    totalPaidAmount = _useState26[0],
    setTotalPaidAmount = _useState26[1];
  var _useState27 = useState(0),
    _useState28 = _slicedToArray(_useState27, 2),
    totalDue = _useState28[0],
    setTotalDue = _useState28[1];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: 'date',
    key: 'date',
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Montant Total"
    }),
    dataIndex: 'amount',
    key: 'amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Montant Pay\xE9"
    }),
    dataIndex: 'paid_amount',
    key: 'paid_amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Reste \xE0 payer"
    }),
    dataIndex: 'remain_amount',
    key: 'remain_amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Auteur"
    }),
    dataIndex: 'user',
    key: 'user',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Commentaire"
    }),
    dataIndex: 'comment',
    key: 'comment',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Paiement"
    }),
    dataIndex: 'bill',
    key: 'bill',
    render: function render(bill) {
      return /*#__PURE__*/_jsxs(Space, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            setSelectedBill(bill);
            setShowInvoice(true);
          },
          type: "default",
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(Receipt, {
              size: 22
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          disabled: bill.bill_settlements.length == 0,
          onClick: function onClick() {
            setSelectedBill(bill);
            setShowSettleHistory(true);
          },
          type: "default",
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(CashStack, {
              size: 22
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            setSelectedBill(bill);
            setShowAddSettlement(true);
          },
          type: "default",
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(PlusCircleFill, {
              size: 22
            })
          })
        })]
      });
    }
  }];
  useEffect(function () {
    setIsDataLoading(true);
    setIsDataChanged(false);
    axios.get(Common.baseApiUrl + "getcompany/" + id + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCompany(response.data.company);
        axios.get(Common.baseApiUrl + "getcompanyorders/" + response.data.company.id + "/" + from + "/" + to + "/" + Common.currentUser.id).then(function (oresponse) {
          if (oresponse.data.status == 200) {
            setOrders([]);
            setTotalOrderAmount(0);
            setTotalPaidAmount(0);
            setTotalDue(0);
            oresponse.data.bills.forEach(function (e) {
              setOrders(function (prev) {
                return [].concat(_toConsumableArray(prev), [{
                  date: e.created_at,
                  amount: e.total_amount,
                  paid_amount: e.paid_amount,
                  remain_amount: e.total_amount - e.paid_amount,
                  user: e.user.prenom + " " + e.user.nom,
                  comment: e.comment,
                  bill: e
                }]);
              });
              setTotalOrderAmount(function (prev) {
                return prev + e.total_amount;
              });
              setTotalPaidAmount(function (prev) {
                return prev + e.paid_amount;
              });
              setTotalDue(function (prev) {
                return prev + (e.total_amount - e.paid_amount);
              });
            });
          } else {
            notification.error({
              message: "Erreur !",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur !",
            description: "Une erreur est survenue " + error.toString()
          });
        });
      } else {
        notification.error({
          message: "Erreur !",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur !",
        description: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged, from, to]);
  return /*#__PURE__*/_jsx(Container, {
    children: isDataLoading ? /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: company && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            sm: {
              span: 4
            },
            children: /*#__PURE__*/_jsx(Button, {
              type: "default",
              icon: /*#__PURE__*/_jsx(CartPlusFill, {}),
              onClick: function onClick() {
                setShowNewOrder(true);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: " Nouvelle commande"
              })
            })
          }), /*#__PURE__*/_jsxs(Col, {
            lg: {
              span: 4,
              offset: 5
            },
            md: {
              span: 5,
              offset: 4
            },
            sm: {
              span: 6,
              offset: 2
            },
            children: [/*#__PURE__*/_jsx("h2", {
              children: /*#__PURE__*/_jsx("b", {
                children: company.label
              })
            }), /*#__PURE__*/_jsxs("h4", {
              children: ["Solde: ", company.balance.toLocaleString("Fr")]
            }), /*#__PURE__*/_jsx(Divider, {})]
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 1,
            md: 1
          }), /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsx(Form, {
              layout: "vertical",
              size: "large",
              onFinish: function onFinish(values) {
                setFrom(moment(new Date(values.range[0].$d)).format());
                setTo(moment(new Date(values.range[1].$d)).format());
              },
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "range",
                  rules: [{
                    required: true,
                    message: "Champs obligatoire"
                  }],
                  children: /*#__PURE__*/_jsx(RangePicker, {
                    needConfirm: false,
                    format: "DD-MM-YYYY",
                    presets: [{
                      label: 'Hier',
                      value: dayjs().add(-1, 'd')
                    }, {
                      label: "Aujourdh'hui",
                      value: dayjs().add(0, 'd')
                    }]
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    icon: /*#__PURE__*/_jsx(Search, {}),
                    type: "primary",
                    htmlType: "submit",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Recherche"
                    })
                  })
                })]
              })
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                fontWeight: "bold",
                fontStyle: 'italic'
              },
              children: ["Commandes du ", new Date(from).toLocaleDateString("Fr"), " Au ", new Date(to).toLocaleDateString("Fr")]
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    borderRadius: "7px",
                    padding: "15px 12px",
                    textAlign: "center",
                    background: "#F0E1DF"
                  },
                  children: /*#__PURE__*/_jsx(Statistic, {
                    prefix: /*#__PURE__*/_jsx(Icon, {
                      icon: "flat-color-icons:sales-performance",
                      width: "48",
                      height: "48"
                    }),
                    valueStyle: {
                      color: "#010101"
                    },
                    title: /*#__PURE__*/_jsx("b", {
                      style: {
                        color: '#010101'
                      },
                      children: "Total commandes"
                    }),
                    value: totalOrderAmount
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    borderRadius: "7px",
                    padding: "15px 12px",
                    textAlign: "center",
                    background: "#ECE4DD"
                  },
                  children: /*#__PURE__*/_jsx(Statistic, {
                    prefix: /*#__PURE__*/_jsx(Icon, {
                      icon: "flat-color-icons:money-transfer",
                      width: "48",
                      height: "48"
                    }),
                    valueStyle: {
                      color: "#010101"
                    },
                    title: /*#__PURE__*/_jsx("b", {
                      style: {
                        color: '#010101'
                      },
                      children: "Total pay\xE9"
                    }),
                    value: totalPaidAmount
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    borderRadius: "7px",
                    padding: "15px 12px",
                    textAlign: "center",
                    background: "#E8EFFD"
                  },
                  children: /*#__PURE__*/_jsx(Statistic, {
                    prefix: /*#__PURE__*/_jsx(Icon, {
                      icon: "flat-color-icons:high-priority",
                      width: "48",
                      height: "48"
                    }),
                    valueStyle: {
                      color: "#010101"
                    },
                    title: /*#__PURE__*/_jsx("b", {
                      style: {
                        color: '#010101'
                      },
                      children: "Total impay\xE9s"
                    }),
                    value: totalDue
                  })
                })
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Table, {
              columns: cols,
              bordered: true,
              responsive: true,
              dataSource: orders,
              size: "small"
            })]
          })]
        }), /*#__PURE__*/_jsx(Modal, {
          title: /*#__PURE__*/_jsx("b", {
            children: "NOUVELLE COMMANDE CLIENT"
          }),
          open: showNewOrder,
          destroyOnClose: true,
          footer: null,
          width: "85%",
          onCancel: function onCancel() {
            setShowNewOrder(false);
          },
          children: /*#__PURE__*/_jsx(AddCustomerOrder, {
            company: company,
            handler: function handler() {
              setShowNewOrder(false);
              notification.success({
                message: "Ok!",
                description: "Opération réussie"
              });
              setIsDataChanged(true);
            }
          })
        }), selectedBill && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Drawer, {
            title: /*#__PURE__*/_jsx("b", {
              children: "FACTURE"
            }),
            width: "80%",
            open: showInvoice,
            onClose: function onClose() {
              setShowInvoice(false);
            },
            destroyOnClose: true,
            extra: /*#__PURE__*/_jsx(Space, {
              children: /*#__PURE__*/_jsx(ReactToPrint, {
                content: function content() {
                  return ref.current;
                },
                children: /*#__PURE__*/_jsx(PrintContextConsumer, {
                  children: function children(_ref) {
                    var handlePrint = _ref.handlePrint;
                    return /*#__PURE__*/_jsx(Button, {
                      onClick: handlePrint,
                      type: "ghost",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Imprimer"
                      })
                    });
                  }
                })
              })
            }),
            children: /*#__PURE__*/_jsx(Invoice, {
              invoice: selectedBill,
              ref: ref
            })
          }), /*#__PURE__*/_jsx(Modal, {
            title: /*#__PURE__*/_jsx("b", {
              children: "R\xE9gler la facture"
            }),
            open: showAddSettlement,
            onCancel: function onCancel() {
              setShowAddSettlement(false);
            },
            destroyOnClose: true,
            footer: null,
            width: {
              xs: '90%',
              sm: '80%',
              md: '70%',
              lg: '60%',
              xl: '50%',
              xxl: '40%'
            },
            children: /*#__PURE__*/_jsx(AddCustomerSettlement, {
              bill: selectedBill,
              handler: function handler() {
                setIsDataChanged(true);
                setShowAddSettlement(false);
              }
            })
          }), /*#__PURE__*/_jsx(Modal, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Historique des paiements"
            }),
            open: showSettleHistory,
            onCancel: function onCancel() {
              setShowSettleHistory(false);
            },
            destroyOnClose: true,
            footer: null,
            width: {
              xs: '90%',
              sm: '80%',
              md: '70%',
              lg: '60%',
              xl: '50%',
              xxl: '40%'
            },
            children: /*#__PURE__*/_jsx(SettlementHistory, {
              bill: selectedBill,
              handler: function handler() {
                setIsDataChanged(true);
                setShowSettleHistory(false);
              }
            })
          })]
        })]
      })
    })
  });
};
export default CompanyDetails;